import {mapSnapshot} from '../api'
import {firestore, getBasePath} from '../firebase'
import * as ProjectActions from "./ProjectActions";
import * as TaskActions from "./TaskActions";

export const FETCH_CLIENTS = "FETCH_CLIENTS";
export function fetchClients(){
    return {
        type: FETCH_CLIENTS,
        payload: firestore.collection(getBasePath() + "/clients").get().then(sh => mapSnapshot(sh))
    };
}
export function fetchClientsIfNeeded(){
    return (dispatch, state) => {
        const {clients} = state();
        // if(Object.keys(clients.items).length === 0 && !clients.fetching){
        if(!clients.fetched && !clients.fetching){
            dispatch(fetchClients());
        }
    };
}

export function loadAllClientsAndProjects(){
    return (dispatch, state) => {
        const {clients} = state();
        // if(Object.keys(clients.items).length === 0 && !clients.fetching){
        if(!clients.fetched && !clients.fetching){
            dispatch(fetchClients());
        }
    };
}

export const SAVE_CLIENT = "SAVE_CLIENT";
export function saveClient(params){

    if(!params || !params.name){
        throw new Error("Error creating project: params not ok")
    }

    if(params.id){
        return {
            type: SAVE_CLIENT,
            payload: firestore
                .doc(getBasePath() + "/clients/" + params.id)
                .update({
                    name: params.name
                })
                .then(() => params)
                .then(sh => mapSnapshot(sh))
        };
    }else{
        return {
            type: SAVE_CLIENT,
            payload: firestore
                .collection(getBasePath() + "/clients")
                .add({
                    name: params.name
                })
                .then(sh => mapSnapshot(sh))
        };
    }
}

export function saveClientProjectTask(clientParams, projectParams, taskParams){
    return async dispatch => {
        const client = await (await firestore
            .collection(getBasePath() + "/clients")
            .add(clientParams))
            .get();

        projectParams.client_id = client.id;
        projectParams.client = client.ref;

        const project = await (await firestore
            .collection(getBasePath() + "/projects")
            .add(projectParams))
            .get();

        taskParams.client_id = client.id;
        taskParams.client = client.ref;
        taskParams.project_id = project.id;
        taskParams.project = project.ref;

        await (await firestore
            .collection(getBasePath() + "/tasks")
            .add(taskParams))
            .get();

        dispatch(fetchClients());
        dispatch(ProjectActions.fetchProjects());
        dispatch(TaskActions.fetchTasks());
    };
}


// WEBPACK FOOTER //
// ./src/actions/ClientActions.js